import React, { useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core";

import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const ImportCsvModal = ({ open, onClose }) => {

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImport = async () => {

    if (!file) {
      toast.error("Seleccione un archivo CSV");
      return;
    }

    const formData = new FormData();

    formData.append("file", file);

    try {

      setLoading(true);

      await api.post("/contacts/import-csv", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      toast.success("Contactos importados");

      onClose();

      window.location.reload();

    } catch (err) {

      toastError(err);

    } finally {

      setLoading(false);

    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>

      <DialogTitle>
        Importar contactos CSV
      </DialogTitle>

      <DialogContent>

        <Typography variant="body2" gutterBottom>
          El archivo debe contener:
        </Typography>

        <Typography variant="body2">
          name,number
        </Typography>

        <input
          type="file"
          accept=".csv"
          onChange={(e) => setFile(e.target.files[0])}
          style={{ marginTop: 20 }}
        />

      </DialogContent>

      <DialogActions>

        <Button
          onClick={onClose}
          disabled={loading}
        >
          Cancelar
        </Button>

        <Button
          color="primary"
          variant="contained"
          onClick={handleImport}
          disabled={loading}
        >
          Importar
        </Button>

      </DialogActions>

    </Dialog>
  );
};

export default ImportCsvModal;